export default "__VITE_ASSET__BzaH3BNp__"